// !==================================
// ! Deletion State Reducer's actions:
// !==================================
const DELETE_ACTIONS = {
  ACTIVATE_DELETION_MODE: 'ACTIVATE_DELETION_MODE',
  ACTIVATE_DELETE_CONFIRMATION: 'ACTIVATE_DELETE_CONFIRMATION',
  DEACTIVATE_DELETION_MODE: 'DEACTIVATE_DELETION_MODE',
  DEACTIVATE_DELETE_CONFIRMATION: 'DEACTIVATE_DELETE_CONFIRMATION',
  RESET_DELETION_STATE: 'RESET_DELETION_STATE',
  UPDATE_DELETION_STATE: 'UPDATE_DELETION_STATE',
  TOGGLE_ADD_ITEM_TO_SELECTED_ITEMS: 'TOGGLE_ADD_ITEM_TO_SELECTED_ITEMS',
  SUCCESSFUL_DELETION: 'SUCCESSFUL_DELETION',
  GENERATE_ALLOWED_ITEMS_LIST: 'GENERATE_ALLOWED_ITEMS_LIST',
  TOGGLE_CHECK_ALL_ALLOWED_ITEMS: 'TOGGLE_CHECK_ALL_ALLOWED_ITEMS',
};

export default DELETE_ACTIONS;



// WEBPACK FOOTER //
// ./src/MultiDeletionFunctionality/@state_manager/actions.js